// extracted by mini-css-extract-plugin
export default {"billing-summary-header":"billing-summary-header_L1arX","billing-summary-tips":"billing-summary-tips_yrtXc"};